import calcCurrentAbility from '../helpers/calcCurrentAbility'
import calcDamageModRanged from '../helpers/calcDamageModRanged'
import buildDamageMod from '../helpers/buildDamageMod'
import calcKnowBonus from '../helpers/calcKnowBonus'
import calcDamageMod from '../helpers/calcDamageMod'
import calcCA from '../helpers/calcCA'
import calcSR from '../helpers/calcSR'

import store from '../store/index'
//----------------
// calc abilities
//----------------
export default function calcAbilities({ pfx, character }) {
  const config = store.getters['combat/getConfig']
  //==============================
  // where dex
  //-----------
  if (pfx == 'dex') {
    //----------------
    // calc ca (base)
    //----------------
    character.ca_base = calcCA(character.dex_cur)
    character.cr_base = character.ca_base
    //---------------
    // calc ca (cur)
    //---------------
    character.ca_cur = calcCurrentAbility({
      base: character.ca_base,
      adjs_tot: character.ca_adjs_tot,
      min: config.min_ca,
      max: config.max_ca,
    })
    // console.log('character.ca_cur = ' + character.ca_cur)
    //---------------
    // calc cr (cur)
    //---------------
    character.cr_cur = calcCurrentAbility({
      base: character.cr_base,
      adjs_tot: character.cr_adjs_tot,
      min: config.min_cr,
      max: config.max_cr,
    })
    // console.log('character.cr_cur = ' + character.cr_cur)
  }
  //==============================
  // where int
  //-----------
  if (pfx == 'int') {
    //---------
    // calc kb
    //---------
    character.know_bonus_percent = calcKnowBonus(character.int_cur)
  }
  //==============================
  // where pow
  //-----------
  if (pfx == 'pow') {
    //--------
    // set mp
    //--------
    character.mp = character.pow_cur

    const isNewCharacterDraft =
      typeof character?.slug !== 'string' || character.slug.trim().length === 0

    if (isNewCharacterDraft) {
      character.mp_cur = character.mp
    }
  }
  //==============================
  // where int or dex
  //------------------
  if (pfx == 'int' || pfx == 'dex') {
    //----------------
    // calc sr (base)
    //----------------
    character.sr_base = calcSR(character.int_cur, character.dex_cur)
    //---------------
    // calc sr (cur)
    //---------------
    character.sr_cur = calcCurrentAbility({
      base: character.sr_base,
      adjs_tot: character.sr_adjs_tot,
      min: 1,
    })
    // console.log('character.sr_cur = ' + character.sr_cur)
  }
  //==============================
  // where str or siz
  //------------------
  if (pfx == 'str' || pfx == 'siz') {
    //---------------------------
    // calc dam mod melee (base)
    //---------------------------
    character.damage_mod_melee_base = calcDamageMod(character.str_cur, character.siz_cur)
    // console.log('character.damage_mod_melee_base = ' + character.damage_mod_melee_base)
    //---------------------------
    // build dam mod melee (cur)
    //---------------------------
    character.damage_mod_melee_cur = buildDamageMod({
      base: character.damage_mod_melee_base.toString(),
      adjs_tot: character.damage_mod_melee_adjs_tot
        ? character.damage_mod_melee_adjs_tot.toString()
        : '',
    })
    // console.log('character.damage_mod_melee_cur = ' + character.damage_mod_melee_cur)
    //----------------------------
    // calc dam mod ranged (base)
    //----------------------------
    character.damage_mod_ranged_base = calcDamageModRanged(character.str_cur, character.siz_cur)
    // console.log('character.damage_mod_ranged_base = ' + character.damage_mod_ranged_base)
    //---------------------------
    // build dam mod ranged (cur)
    //---------------------------
    character.damage_mod_ranged_cur = buildDamageMod({
      base: character.damage_mod_ranged_base.toString(),
      adjs_tot: character.damage_mod_ranged_adjs_tot
        ? character.damage_mod_ranged_adjs_tot.toString()
        : '',
    })
    // console.log('character.damage_mod_ranged_cur = ' + character.damage_mod_ranged_cur)
  }
  return character
}
